import React, { useState, useEffect, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { FaSearch, FaPen, FaPlus } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import * as general from '../libs/general';
import Paging from '../components/Paging';
import AdminLayout from '../components/AdminLayout';
import DataTable from '../components/ui/DataTable';

const JobLogs = () => {
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    searchJobLogs();
  }, []);

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchJobLogs({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchJobLogs({ page: page - 1 });
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchJobLogs({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const searchJobLogs = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');
    var params = general.getSession('search_joblogs');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_joblogs');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_contacts', params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/joblog/searchJobLogs', { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
    }
    setIsLoading(false);
  };

  return (
    <div>
      <AdminLayout>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title d-flex align-items-center justify-content-between gap-2">
                  <h2 className="fw-bold">Lịch sử chạy jobs</h2>
                  <form className="form_filter mb-0">
                    <div className="input-group search-block">
                      <input name="keyword"
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Tìm kiếm..."
                        value={searchQuery}
                        onChange={(e) => handleSearchChange(e)}
                      />
                      <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchJobLogs({ page: 0 })}>
                        <FaSearch />
                      </button>
                    </div>
                  </form>
                </div>
                <div className="x_content">
                  <DataTable maxHeight="calc(100vh - 260px)" className="table-normal" data-loading={isLoading}>
                    <table className="table table-striped table-bordered">
                      <thead className="table-primary">
                        <tr>
                          <th width="30px" className="sticky">STT</th>
                          <th>Mã</th>
                          <th>Nội dung</th>
                          <th width="200px"><span>Thời gian</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => (
                          <tr key={item.id}>
                            <td className="sticky">{(pageData.page.number * pageData.page.size) + index + 1}</td>
                            <td className="text-start">{item.code}</td>
                            <td className="text-start">{item.content}</td>
                            <td><span title={general.formatDateTime(item.createdAt)}></span> {general.formatDateTime3(item.createdAt)}</td>
                          </tr>
                        ))}

                        {message === '' && pageData.page && pageData.page.content.length === 0 && (
                          <tr>
                            <td colSpan="4" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {message !== '' && (
                          <tr>
                            <td colSpan="4" className="text-center">{message}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </DataTable>
                  <div className="mt-2 d-flex justify-content-end align-items-center">
                    <Paging
                      pageData={pageData}
                      onPageChange={handlePageChange}
                      onItemsPerPageChange={handleChangeItemsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  );
}
export default JobLogs;